import { json2csvAsync } from 'json-2-csv';
import moment from 'moment';
import { get } from 'lodash';

const normalizeRow = (item = {}, normalizedPayout = {}) => {
  const bank_account = get(item, 'bank_account', {});
  const bookingId = get(item, 'booking.id');
  const listing = get(item, 'listing', {});
  const payoutDate = item.max_payout_processed_date || normalizedPayout.payout_date;
  return {
    line_type: item.category || 'payout',
    payout_id: item.payout_id,
    payout_description: (bank_account.name && bank_account.last4) && `Payout to ${bank_account.name} - ${bank_account.last4}`,
    payout_total: get(item, 'total_amount.display_string'),
    payout_date: moment(payoutDate).format('YYYY-MM-DD'),
    booking_id: get(item, 'booking.id'),
    booking_url: bookingId && `https://www.peerspace.com/inbox/${bookingId}`,
    booking_ended: get(item, 'booking.dts_end') ? moment(get(item, 'booking.dts_end')).format('YYYY-MM-D') : '',
    booking_use_type: listing.use_type,
    guest_id: get(item, 'guest.ssoid'),
    guest_first: get(item, 'guest.name.first'),
    guest_last: get(item, 'guest.name.last'),
    listing_id: listing.id,
    listing_title: listing.title,
    listing_city: listing.city,
    listing_state: listing.state,
    line_total: get(item, 'amount.display_string')
  };
};

const payloadCSV = (payouts = []) => {
  const payload = payouts.reduce((rows, payout = {}) => {
    const normalizedPayout = normalizeRow(payout);
    rows.push(normalizedPayout);
    if (payout.items) {
      const lineItems = payout.items.map((item) => normalizeRow(item, normalizedPayout));
      rows.push(...lineItems);
    }
    return rows;
  }, []);

  return _.sortBy(payload, ['payout_date', 'payout_id', 'line_type']);
};

export const downloadCSV = (csvString, startDate, endDate) => {
  const blob = new Blob([csvString], { type: 'text/csv;charset=utf-8;' });
  if (navigator.msSaveBlob) { // IE 10+
    navigator.msSaveBlob(blob, 'payouts.csv');
  } else {
    const link = document.createElement('a');
    if (link.download !== undefined) {
      // Testing for support since it only works on HTML5
      const url = URL.createObjectURL(blob);
      link.setAttribute('href', url);
      link.setAttribute('download', `Payouts (${startDate} - ${endDate}).csv`);
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }
};

export const generateCSV = (payouts) => {
  const formattedPayouts = payloadCSV(payouts);
  return json2csvAsync(formattedPayouts, {
    emptyFieldValue: ''
  });
};
